import { defineComponent as _defineComponent } from 'vue'
import {
  computed, onMounted, PropType, ref
} from 'vue';
import { BcxFormField } from '@/models/BcxForm';
import BCXSearchSelect from '@/components/molecules/BCXSearchSelect.vue';
import BCXTextArea from '@/components/molecules/forms/BCXTextArea.vue';
import BCXCheckbox from '@/components/molecules/forms/BCXCheckbox.vue';
import { useDebounceFn, useVModel } from '@vueuse/core';
import BCXDatepickerField from '@/components/molecules/forms/datepicker/BCXDatepickerField.vue';
import BCXCurrencyInput from '@/components/molecules/forms/BCXCurrencyInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXFormField',
  props: {
  field: {
    type: Object as PropType<BcxFormField>,
    default: null
  },
  hasError: Boolean,
  value: {
    type: [String, Number, Boolean],
    default: ''
  }
},
  emits: ['input', 'blur'],
  setup(__props, { emit }) {

const props = __props;





const vmValue = useVModel(props);

const vmDateValue = computed({
  get() {
    return props.value;
  },
  set(date: string | Date) {
    emit('input', typeof date === 'string' ? date : date.toISOString().slice(0, 10));
  }
});

const onDelayedBlur = useDebounceFn(() => {
  emit('blur');
}, 100);

const isTextareaEnlarged = ref(false);

const charsLeft = computed(() => {
  if (props.field.textOptions && props.field.textOptions.maxLength) {
    return props.field.textOptions.maxLength - vmValue.value.length;
  }
  return 0;
});

const style = computed(() => {
  const style: any = {
    width: props.field.width
  };
  if (props.field.justify === 'end') style.marginLeft = 'auto';
  return style;
});

onMounted(() => {
  if (props.field.isTextareaEnlarged) {
    isTextareaEnlarged.value = true;
  }
});


return { __sfc: true,props, emit, vmValue, vmDateValue, onDelayedBlur, isTextareaEnlarged, charsLeft, style, BCXSearchSelect, BCXTextArea, BCXCheckbox, BCXDatepickerField, BCXCurrencyInput }
}

})